export enum DealsType {
  MY,
  ALL,
}
